import React, { useEffect } from 'react';
import { Box, Card, Divider } from '@material-ui/core';
import { ShoppingCart as ShoppingCartIcon } from '@material-ui/icons';

import CardTitle from '../../../common/card/CardTitle';
import CardContent from '../../../common/card/CardContent';
import InlineFile from '../../../common/inline/InlineFile';
import InlineForm from '../../../common/inline/InlineForm';
import InlineFormik from '../../../common/inline/InlineFormik';
import { InputAcceptType } from '../../../common/api/File.interface';
import {
  BaseSporCardProps,
  SupplierPurchaseOrder
} from '../../supplier/Supplier.interface';
import { useUpdateSpor } from '../../supplier/Supplier.hooks';
import { WorkflowEntity } from '../../workflow/Workflow.interface';
import { useTaskEntityFields } from '../../workflow/Workflow.hooks';
import OrderQuoteTable from './OrderQuoteTable';

const OrderDetailsFormCard: React.FC<BaseSporCardProps> = (
  props: BaseSporCardProps
) => {
  const { spor, onChange, onUpdate, onError } = props;
  const { isFieldDisabled } = useTaskEntityFields<WorkflowEntity.Spor>(
    spor.task
  );
  const { updatedSpor, isUpdating, updateError, updateSpor } = useUpdateSpor(
    spor.id
  );

  useEffect(() => {
    if (updatedSpor) {
      onChange?.(updatedSpor);
      onUpdate?.();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedSpor]);

  useEffect(() => {
    if (updateError) {
      onError?.(updateError);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateError]);

  return (
    <Card>
      <CardTitle>
        <ShoppingCartIcon />
        Section 3: Order Details
      </CardTitle>
      <OrderQuoteTable {...props} />
      <Box mb={2}>
        <Divider />
      </Box>
      <CardContent padding='large'>
        <InlineFormik
          error={updateError}
          isSubmitting={isUpdating}
          initialValues={{ attachments: spor.attachments }}
          onSubmit={(values: Pick<SupplierPurchaseOrder, 'attachments'>) => {
            updateSpor(values);
            onChange?.(values);
          }}
        >
          <InlineForm>
            <InlineFile
              multiple
              name='attachments'
              uploadPath='attachments'
              label='Attach any additional information for the order.'
              // Accept all file types
              // inputType={InputAcceptType.Documents}
              disabled={isFieldDisabled('attachments')}
            />
          </InlineForm>
        </InlineFormik>
      </CardContent>
    </Card>
  );
};

export default OrderDetailsFormCard;
